import nationalAverage from './nationalAverage';
const categoryData = {
  intro: {
    title1: 'The State of Housing in',
    title2: 'America'
  },
  supply: {
    title1: 'HOUSING',
    title2: 'SHORTAGE',
    copy:
      'The housing shortage tracker shows the availability of new homes to new jobs from October 2021 to October 2022. REALTORS® use this to track whether the housing supply will meet demand in the near-term.',
    copy2: 'Low supply typically results in elevated home prices.',
    average1: `1 single-family permit issued for every ${nationalAverage.supply} new jobs.*`,
    disclaimer:
      '*In a balanced market, a single-family permit would be issued for every 2 new jobs.'
  },
  appreciation: {
    title1: 'HOME PRICE',
    title2: 'APPRECIATION',
    copy:
      'The National Association of REALTORS® tracks the year-over-year change in median home prices, which allows buyers and sellers to easily compare their local market with housing prices in other parts of the country.',
    average1: `$${nationalAverage.medianPrice} median single-family home price`,
    average2: `+${nationalAverage.yoyChange}% year-over-year`
  },
  affordability: {
    title1: 'HOUSING',
    title2: 'AFFORDABILITY',
    copy:
      'The Housing Affordability Index from the National Association of REALTORS® tracks whether a typical family can afford the mortgage payments on a typical home.',
    copy2:
      'In general, a higher HAI number indicates that homes will be more affordable in that area.',
    average1: `Current average: ${nationalAverage.affordability}`,
    average2: 'Historical average: 138'
  },
  forecast: {
    title1: 'HOUSING DEMAND',
    title2: 'FORECAST',
    copy:
      'Population gain or loss impacts housing demand. When population growth is high, housing prices often also rise. When growth is slow or negative, home prices may flatline or fall. By tracking population change over time, REALTORS® can estimate future housing demand.',
    average1: `10-yr change: +${nationalAverage.popChange}%`,
    average2: '2011 population: 311,591,919',
    average3: '2021 population: 331,893,745'
  },
  disclaimer: {
    copy:
      'Not all real estate agents are REALTORS®. Only agents who belong to the National Association of REALTORS® (NAR) and adhere to its code of ethics can call themselves a REALTOR® and use their trademark. REALTORS® gain expertise through ongoing research, education, resources and thought leadership from NAR.'
  }
};

export default categoryData;
